import ReactGA from "react-ga4";

const initializeGA = () => {
  const measurementId = window.GA_MEASUREMENT_ID;
  if (!measurementId) {
    console.warn("Google Analytics Measurement ID is not set");
    return;
  }

  ReactGA.initialize(measurementId, {
    testMode: window.CLIENT_BASE_URL !== "https://client.traxero.net",
  });

  window.onerror = function (message, source, lineno, colno, error) {
    ReactGA.event({
      category: "JavaScript Error",
      action: "Unhandled error",
      label: `Message: ${message}, Source: ${source}, Line: ${lineno}, Column: ${colno}, Error object: ${JSON.stringify(
        error,
      )}`,
    });
  };
};

export default initializeGA;
